import { paths } from 'src/routes/paths';

export const APP_VERSION = process.env.REACT_APP_VERSION;
export const CRYPTO = process.env.REACT_APP_CRYPTO;

export const HOST_API = process.env.REACT_APP_HOST_API;
export const HOST_ENV = process.env.REACT_APP_ENV;

export const STUDENT_PORTAL_API = (process.env.REACT_APP_STUDENT_PORTAL || '').trim().replace(/\/+$/, '');

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
